import { useNavigate } from '@tanstack/react-router'
import { ZapIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface NudgingSubscriptionBannerProps {
  contentFlow?: 'horizontal' | 'vertical'
  isAdmin?: boolean
  isFreeTrialAvailable?: boolean
}

export const NudgingSubscriptionBanner = ({
  contentFlow = 'horizontal',
  isAdmin = false,
  isFreeTrialAvailable = false,
}: NudgingSubscriptionBannerProps) => {
  const navigate = useNavigate()

  const goToPricingPage = () => {
    void navigate({
      to: '/pricing',
    })
  }

  const content = isAdmin
    ? isFreeTrialAvailable
      ? 'Subscribe to a plan to unlock premium features and enjoy a 14-day free trial.'
      : 'Subscribe to a plan again to regain access to premium features.'
    : 'Please contact your Admins to subscribe to a plan and unlock premium features.'

  return (
    <div
      className={cn(
        'flex',
        'bg-slate-800',
        contentFlow === 'horizontal' && [
          'items-center justify-between gap-x-[45px] rounded-[10px] p-5',
          {
            'justify-center': !isAdmin,
          },
        ],
        contentFlow === 'vertical' && [
          'flex-col items-center gap-y-8 rounded-[20px] py-[50px]',
          {
            'px-4 py-[80px]': !isAdmin,
          },
        ]
      )}
    >
      <p
        className={cn(
          'text-white',
          {
            'text-center text-lg font-semibold lg:text-2xl': contentFlow === 'vertical',
            'max-w-[550px]': contentFlow === 'vertical' && isAdmin,
            'max-w-max': contentFlow === 'vertical' && !isAdmin,
          },
          {
            'text-left text-base font-normal': contentFlow === 'horizontal',
            'mx-[70px] text-center': contentFlow === 'horizontal' && !isAdmin,
          }
        )}
      >
        {content}
      </p>
      {isAdmin && (
        <div>
          {isFreeTrialAvailable && (
            <Button type="button" variant="default" className={cn('flex space-x-2')} onClick={goToPricingPage}>
              <ZapIcon size={16} />
              <span>Start Free Trial 14 Days</span>
            </Button>
          )}
          {!isFreeTrialAvailable && (
            <Button type="button" variant="default" className={cn('flex space-x-2')} onClick={goToPricingPage}>
              <ZapIcon size={16} />
              <span>Upgrade Subscription</span>
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
